import React, { useEffect } from 'react'
// import CountiesCodeModal from '../../modals/CountriesCodeList'
import { checkTextTranslation, priceStandardView } from '../../utils/useful'
import mapboxgl, { accessToken, setRTLTextPlugin } from "mapbox-gl";
import { Map as LeafletMap, Marker, Popup, TileLayer, Circle, useLeaflet, FeatureGroup, Tooltip } from "react-leaflet";
import L from 'leaflet'
import Slider, { SliderTooltip } from 'rc-slider';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import '../../../node_modules/leaflet-geosearch/dist/geosearch.css';
import '../../../node_modules/react-leaflet-markercluster/dist/styles.min.css';

import MarkerClusterGroup from 'react-leaflet-markercluster';
import moment from 'moment'
import { nanoid } from "nanoid";
import SocketServices from "../../utils/socket.services";
import { getOneThing, getObject } from "../../utils/useful";

const createSliderWithTooltip = Slider.createSliderWithTooltip;


let apiKey = 'pk.eyJ1IjoicG91eWFwZXpobWFuIiwiYSI6ImNrZHZwd2JiYTBzeHgyeWtqa2xodmNrdnQifQ.W9n1rw2PX1V1PjrcBDitrA'

const myCustomColour = '#583470'
// 
const markerHtmlStyles = `
  width: 2rem;
  height: 2rem;
  display: block;
  left: -1rem;
  top: -1rem;
  position: relative;
  border-radius: 2rem 2rem 0;
  transform: rotate(45deg);
  border: 1px solid #FFFFFF`

const colorIcon = L.divIcon({
    className: "my-custom-pin",
    iconAnchor: [0, 24],
    labelAnchor: [-6, 0],
    popupAnchor: [0, -36],
    html: `<span style="${markerHtmlStyles}" />`
})

const colorIcon1 = L.divIcon({
    className: "my-custom-pin1",
    iconAnchor: [0, 24],
    labelAnchor: [-6, 0],
    popupAnchor: [0, -36],
    html: `<span style="${markerHtmlStyles}" />`
})

const colorIcon2 = L.divIcon({
    className: "my-custom-pin2",
    iconAnchor: [0, 24],
    labelAnchor: [-6, 0],
    popupAnchor: [0, -36],
    html: `<span style="${markerHtmlStyles}" />`
})

const colorIcon3 = L.divIcon({
    className: "my-custom-pin3",
    iconAnchor: [0, 24],
    labelAnchor: [-6, 0],
    popupAnchor: [0, -36],
    html: `<span style="${markerHtmlStyles}" />`
})




const Search = (props) => {
    const { map } = useLeaflet()
    const { provider } = props

    useEffect(() => {
        const searchControl = new GeoSearchControl({
            provider,
        })

        map.addControl(searchControl)
        return () => map.removeControl(searchControl)
    }, [props])

    return null
}



class MapLeafletWidget extends React.Component {

    state = {
        selectedCountry: {},
        operator: 'location',
        zoom: 13,
        slider: 3,
        radius: 1000,
        position: [35.7575, 51.41],
        topicId: nanoid(10),
        markers: []

    }

    componentDidMount() {

        this.setState({ radius: Math.pow(10, this.state.slider) }, () => {
            this.init()
        })

    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.data != this.props.data && this.props.data != this.state.data) {
    //         this.init()
    //     }
    // }

    init() {

        if (this.props.data?.things && Array.isArray(this.props.data?.things)) {
            let promises = []
            let markers = {}
            let things = {}


            this.props.data.things.forEach(thing => {
                console.log(thing)

                promises.push(new Promise((resolve, reject) => {

                    getOneThing({ id: thing }, (fetchResult, fetchError, status) => {
                        SocketServices.addTopic(this.state.topicId, thing, 'things', null, this.updateData)
                        if (fetchResult.info?.location) {
                            // console.log(fetchResult)
                            markers[thing] = fetchResult.info?.location
                            things[thing] = fetchResult.info

                        }
                        resolve()
                        // this.setState({ data: fetchResult.info })
                    })

                }))

            })

            Promise.all(promises).then(() => {
                // let markers = []
                // console.log(things)
                this.setState({ things, rawMarkers: markers }, () => {
                    this.setMarkers(markers, true)
                })
                // console.log(markers)
            })
        }



    }

    componentWillUnmount() {
        if (this.props.data?.things && Array.isArray(this.props.data?.things)) {
            this.props.data.things.forEach(thing => {

                SocketServices.removeTopic(this.state.topicId, thing, 'things')
            })
        }
    }



    updateData = (newData, id) => {


        // console.log(newData)
        // console.log("newData")

        if (newData) {
            let thing
            if (this.state.things) {
                thing = this.state.things[id]
            }

            if (thing) {
                let latitude = getObject(newData, thing.latitude)
                let longitude = getObject(newData, thing.longitude)

                // console.log(latitude)
                // console.log(longitude)
                let markers = this.state.rawMarkers
                if (markers[id] && latitude && longitude) {
                    markers[id].coordinates = [longitude, latitude]
                    // console.log("markers")

                    // console.log(markers)
                    this.setState({ rawMarkers: markers }, () => {
                        this.setMarkers(markers)
                    })
                }

            }
        }


        // let data = this.state.data
        // data.splice(0, 0, { cDate: new Date(), data: newData })
        // data = { ...data, ...newData }
        // this.setState({ data })
        // console.log("updateData")
    }




    setMarkers(data, setBound) {
        console.log("setMarkers")
        let markers = []
        let bounds = []
        // return
        Object.entries(data).forEach(([key, element]) => {

            let object = { _id: key, id: element._id, data: element.data, lat: Number(element.coordinates[1]), lng: Number(element.coordinates[0]), position: [Number(element.coordinates[1]), Number(element.coordinates[0])] }
            markers.push(object)
            bounds.push([Number(element.coordinates[1]), Number(element.coordinates[0])])
        });
        // console.log("markers")

        // console.log(markers)
        this.setState({ markers }, () => {

            this.setState({ show: true }, () => {
                setTimeout(() => {
                    this.setState({ show: true }, () => {
                        // console.log(this.map)
                        let map = this.map.leafletElement
                        // let layer = this.customAreaRef
                        // console.log(map.leafletElement)

                        // console.log(this.groupRef)

                        // let group = this.groupRef.leafletElement; //get native featureGroup instance
                        if (bounds && bounds.length > 0) {
                            if (setBound) {
                                map.fitBounds(bounds);
                            }
                        }

                        setTimeout(() => {
                            // console.log(this.group)

                            markers.forEach((markerRef, index) => {
                                let marker = this['marker-' + markerRef.id]
                                // console.log(marker)
                                if (marker && marker.leafletElement._icon) {
                                    // console.log(marker.leafletElement._icon.className)

                                    marker.leafletElement._icon.className = marker.leafletElement._icon.className + ' marker-' + markerRef.id
                                }
                            });
                        }, 500);

                        // this.map.fitBounds(markers)
                    })
                }, 50);
            })
        })
    }



    // init11() {

    //     this.setState({ show: true })

    //     if (this.props.data) {
    //         let data = JSON.parse(JSON.stringify(this.props.data))
    //         this.setState({ data })

    //         if (data && Array.isArray(data) && data[0] != null && data[1] != null && !data[0].coordinates) {

    //             setTimeout(() => {
    //                 let object = { lat: Number(data[0]), lng: Number(data[1]), position: [Number(data[0]), Number(data[1])] }

    //                 if (data[2] != null) {
    //                     object.slider = Number(Math.log10(data[2]))
    //                     setTimeout(() => {

    //                         this.setState({ radius: data[2] })
    //                     }, 50);

    //                     // console.log(data[2])
    //                 }
    //                 object.data = data

    //                 this.setState(object, () => {

    //                     this.setState({ show: false }, () => {
    //                         this.setState({ show: true })
    //                     })

    //                 })
    //             }, 100);
    //         } else if (data && Array.isArray(data)) {



    //         } else if (data && data.lat != null && data.lng != null) {
    //             setTimeout(() => {
    //                 let object = { lat: Number(data.lat), lng: Number(data.lng), position: [Number(data.lat), Number(data.lng)] }


    //                 object.data = data
    //                 console.log(object)
    //                 this.setState(object, () => {

    //                     this.setState({ show: false }, () => {
    //                         setTimeout(() => {
    //                             this.setState({ show: true })
    //                         }, 50);
    //                     })
    //                 })
    //             }, 100);

    //         } else if (data.coordinates) {
    //             setTimeout(() => {

    //                 let object = { lat: Number(data.coordinates[1]), lng: Number(data.coordinates[0]), position: [Number(data.coordinates[1]), Number(data.coordinates[0])] }
    //                 this.setState(object, () => {

    //                     this.setState({ show: false }, () => {
    //                         setTimeout(() => {
    //                             this.setState({ show: true })
    //                         }, 50);
    //                     })
    //                 })
    //             }, 100);

    //         } else {

    //             this.setState({ show: true })
    //         }
    //     }
    // }



    // initMap() {
    //     this.setState({ show: true }, () => {

    //         const map = new mapboxgl.Map({
    //             container: this.mapContainer,
    //             style: 'mapbox://styles/mapbox/light-v10',
    //             center: this.props.data ? this.props.data : [51.41, 35.7575],
    //             zoom: this.state.zoom,
    //             width: '100%',


    //             accessToken: "pk.eyJ1IjoicG91eWFwZXpobWFuIiwiYSI6ImNrZHZwd2JiYTBzeHgyeWtqa2xodmNrdnQifQ.W9n1rw2PX1V1PjrcBDitrA"
    //         });

    //         let lat = 51.41
    //         if (this.props.data) {
    //             lat = Array.isArray(this.props.data) ? this.props.data[1] : this.props.data.lat
    //         }


    //         if (this.props.data) {
    //             var el = document.createElement('div');
    //             el.className = 'marker';
    //             let lng = Array.isArray(this.props.data) ? this.props.data[0] : this.props.data.lng
    //             let lat = Array.isArray(this.props.data) ? this.props.data[1] : this.props.data.lat

    //             new mapboxgl.Marker(el)
    //                 .setLngLat([lng, lat])
    //                 .addTo(map);
    //         }


    //         map.on('load', function () {


    //         })

    //         map.on('move', (e) => {

    //             this.setState({
    //                 lng: map.getCenter().lng,
    //                 lat: map.getCenter().lat,
    //                 zoom: map.getZoom().toFixed(2)
    //             });

    //         });
    //     })
    // }


    metersToPixelsAtMaxZoom = (meters, latitude) => {
        return meters / 0.075 / Math.cos(latitude * Math.PI / 180)
    }

    onChange = (e) => {
        this.setState({ slider: e, radius: Math.pow(10, e).toFixed(0) })

    }



    changeZoom(event) {
        setTimeout(() => {
            this.lastMove = null
        }, 500);
        this.setState({ zoom: event.target.getZoom() })

    }

    selectIcon(index) {
        switch (index) {
            case 0:
                return colorIcon1
                break;

            case 1:
                return colorIcon2
                break;

            case 2:
                return colorIcon3
                break;

            default:
                return colorIcon;
        }
    }


    render() {

        return (
            <div className="w-100" style={{ position: 'relative' }}>

                {this.state.show && (
                    <div className="w-100" style={{ height: this.props.height ?? 220 }}>
                        <LeafletMap ref={el => this.map = el} center={this.state.position} zoom={this.state.zoom} scrollWheelZoom={false}  >

                            <TileLayer
                                attribution='© <a href="https://www.iotsmile.com">IOTSmile</a>'
                                tileSize={512}
                                url={'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}'}
                                zoomOffset={-1}
                                id='mapbox/light-v10'
                                accessToken='pk.eyJ1IjoicG91eWFwZXpobWFuIiwiYSI6ImNrZHZwd2JiYTBzeHgyeWtqa2xodmNrdnQifQ.W9n1rw2PX1V1PjrcBDitrA'
                            />



                            <MarkerClusterGroup ref={el => this.group = el}>
                                {this.state.markers && Array.isArray(this.state.markers) && this.state.markers.map((prop, index) => {
                                    // console.log(this.state.things)
                                    // console.log(prop._id)
                                    return (
                                        <Marker id={prop.id} ref={el => this['marker-' + prop.id] = el} position={[prop.lat, prop.lng]} icon={this.selectIcon(0)} key={index}>
                                            {this.state.things && this.state.things[prop._id] && this.state.things[prop._id].latestData && (
                                                <Tooltip>
                                                    <div>
                                                        {Object.keys(this.state.things[prop._id].latestData).map((oneKey, index) => {
                                                            return (
                                                                <p key={index}><span className="text-bold">{oneKey}</span>: {JSON.stringify(this.state.things[prop._id].latestData[oneKey])}</p>
                                                            )

                                                        })}

                                                        <p key={index}><span className="text-bold">Date</span>: {moment(this.state.things[prop._id].duDate).format('YYYY MMM DD')}</p>
                                                        <p key={index}><span className="text-bold">Time</span>: {moment(this.state.things[prop._id].duDate).format('HH:mm')}</p>

                                                    </div>

                                                </Tooltip>
                                            )}
                                        </Marker>
                                    )
                                })}
                            </MarkerClusterGroup>


                            <Search provider={new OpenStreetMapProvider()} />

                        </LeafletMap>



                    </div>

                )}

            </div>
        )
    }
}

export default (MapLeafletWidget);